import { PEOPLE_DESK_LOGO, PEOPLE_DESK_LOGO_ALT } from '../../assets/brandAssets';

const VARIANT_STYLES = {
  /** Login, forgot password, marketing */
  full: 'h-auto w-full max-w-[200px] sm:max-w-[240px] object-contain object-center',
  /** Sidebar header — fits h-16 row (~44px tall, proportional width) */
  sidebar: 'h-11 w-auto max-w-[200px] min-w-0 object-contain object-left',
  /** Header / navbar */
  header: 'h-9 w-auto max-w-[120px] sm:max-w-[150px] object-contain object-left',
  /** Collapsed sidebar / mobile compact mark */
  compact: 'h-9 w-9 min-w-[2.25rem] object-contain object-left',
};

/**
 * People Desk brand mark — single asset, object-contain, no crop.
 * @param {{ variant?: 'full' | 'sidebar' | 'header' | 'compact'; className?: string; alt?: string }} props
 */
const BrandLogo = ({ variant = 'full', className = '', alt = PEOPLE_DESK_LOGO_ALT }) => {
  const sizeClass = VARIANT_STYLES[variant] || VARIANT_STYLES.full;

  return (
    <span className="logo-wrapper inline-flex items-center justify-center">
      <img
        src={PEOPLE_DESK_LOGO}
        alt={alt}
        className={`brand-logo block ${sizeClass} ${className}`.trim()}
        decoding="async"
        draggable={false}
      />
    </span>
  );
};

export default BrandLogo;
